export const cldrJsonDataShared = [require("./cldr-data/supplemental.json")];
